export default function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // DonвЂ™t include the rootвЂ™s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
}
